import {
    ICancelReasonItem,
    IOrderCancellation,
    IOrderDetails,
    IOrderDetailsLine,
    IOrderHistoryRequest,
    IOrderUpdateShipTo,
    IOrderDropShip,
    IDeleteLine,
    ILineItemAdd,
    IRelatedItems,
    IAddItem,
    IEscalateOrder,
    IOrderDLineNumOpts,
    IOrderHistoryResult,
} from '../models/order';
import { IAccount } from '../models/company-account';
import { IITAPISResult, IResult } from '../models/result-models';
import { apiGet, apiPost } from './api-utils';

const baseUrl = process.env.REACT_APP_API_URL + '/v1/order';

export const getOrder = async (
    orderNumber: string
): Promise<IResult<IOrderDetails>> => {
    const result = await apiGet<IOrderDetails>(baseUrl + '/' + orderNumber);
    return result;
};

export const orderHistorySearch = async (
    request: IOrderHistoryRequest
): Promise<IResult<IOrderHistoryResult>> => {
    const result = await apiPost<IOrderHistoryRequest, IOrderHistoryResult>(
        baseUrl + '/search',
        request
    );
    return result;
};

export const reorder = async (
    lineItems: IOrderDetailsLine[],
    orderNumber: string
): Promise<IResult<boolean>> => {
    const result = await apiPost<IOrderDetailsLine[], boolean>(
        baseUrl + '/reorder/' + orderNumber,
        lineItems
    );
    return result;
};
export const cancelReasons = async (): Promise<
    IResult<ICancelReasonItem[]>
> => {
    const result = await apiGet<ICancelReasonItem[]>(
        baseUrl + '/cancelReasons'
    );
    return result;
};

export const cancelOrder = async (
    request: IOrderCancellation
): Promise<IResult<IITAPISResult>> => {
    const result = await apiPost<IOrderCancellation, IITAPISResult>(
        baseUrl + '/cancelOrder',
        request
    );
    return result;
};

export const changeShipTo = async (
    update: IOrderUpdateShipTo
): Promise<IResult<boolean>> => {
    const result = await apiGet<boolean>(
        baseUrl +
            '/changeShipTo/' +
            update.orderNumber +
            '/' +
            update.shipToAccount
    );
    return result;
};

export const changeDeliverTo = async (
    request: IOrderDropShip,
    orderNumber: string
): Promise<IResult<IITAPISResult>> => {
    const result = await apiPost<IOrderDropShip, IITAPISResult>(
        baseUrl + '/changeDeliverTo/' + orderNumber,
        request
    );
    return result;
};

export const changeBillTo = async (
    request: IAccount
): Promise<IResult<boolean>> => {
    const result = await apiPost<IAccount, boolean>(
        baseUrl + '/changeBillTo/' + request.accountNumber,
        request
    );
    return result;
};
export const deleteLine = async (
    lineItemToDelete: IDeleteLine
): Promise<IResult<IITAPISResult>> => {
    const result = await apiGet<IITAPISResult>(
        baseUrl +
            '/deleteItem/' +
            lineItemToDelete.orderNumber +
            '/' +
            lineItemToDelete.lineItemId
    );
    return result;
};

export const getRelatedItemsFromOrder = async (
    partNumbers: string[]
): Promise<IResult<IRelatedItems>> => {
    const result = await apiPost<string[], IRelatedItems>(
        baseUrl + '/getRelatedItems',
        partNumbers
    );
    return result;
};

export const addItems = async (
    request: ILineItemAdd
): Promise<IResult<IITAPISResult>> => {
    const result = await apiPost<IAddItem[], IITAPISResult>(
        baseUrl + '/addRelatedItems/' + request.orderNumber,
        request.lineItems
    );
    return result;
};

export const postEscalation = async (
    request: IEscalateOrder
): Promise<IResult<string>> => {
    const result = await apiPost<IEscalateOrder, string>(
        baseUrl + '/EscalateOrder',
        request
    );
    return result;
};

export const orderHold = async (
    orderNumber: string,
    isHold: boolean
): Promise<IResult<boolean>> => {
    const result = await apiGet<boolean>(
        baseUrl + '/holdOrder/' + orderNumber + '/' + isHold
    );
    return result;
};
export const adjustFeaturesEarmold = async (
    orderNumber: string,
    items: IOrderDLineNumOpts[]
): Promise<IResult<IITAPISResult>> => {
    const result = await apiPost<IOrderDLineNumOpts[], IITAPISResult>(
        baseUrl + '/adjust-features-earmold/' + orderNumber,
        items
    );
    return result;
};
export const adjustFeaturesStandard = async (
    orderNumber: string,
    items: IOrderDLineNumOpts[]
): Promise<IResult<IITAPISResult>> => {
    const result = await apiPost<IOrderDLineNumOpts[], IITAPISResult>(
        baseUrl + '/adjust-features-standard/' + orderNumber,
        items
    );
    return result;
};
